var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textHolder"},[_c('div',{attrs:{"id":"content"}},[_vm._v(_vm._s(_vm.msg))]),_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(" See The Code Here ")])])}
var staticRenderFns = []

export { render, staticRenderFns }